var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"type":"date","min":_vm.min,"max":_vm.max},domProps:{"value":_vm.date},on:{"change":_vm.handleOnChange}})}
var staticRenderFns = []

export { render, staticRenderFns }